import React from "react";
import { Stack, IconButton, Button, Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MainLayout from "../MainLayout";
import TableEmptyRow from '../shared/TableEmptyRow';
import axios from "axios";

export default function UserWiseTable({
  reports,
  loading,
  page,
  setPage,
  rowsPerPage,
  totalCount,
  setPdfUrl,
  setPdfDialogOpen,
  setSelectedEmployee
}) {
  const totalPages = Math.ceil(totalCount / rowsPerPage);





  const handleView = async (row) => {
    try {
      const exam_type_id =
        row.exam_type === "Competency Review" ? 1 : 2;

      const ee_id = row.ee_guid;

      // Step 1
      const getResponse = await axios.get(
        `/reports/exam-report/${ee_id}/${exam_type_id}/`,
        { withCredentials: true }
      );

      if (getResponse.status < 200 || getResponse.status >= 300) {
        const errorData = getResponse.data;
        alert(errorData.error || "Failed to fetch exam data");
        return;
      }

      // Step 2
      const postResponse = await axios.post(
        `/reports/exam-report/${ee_id}/${exam_type_id}/`,
        {},
        { withCredentials: true }
      );

      const data = postResponse.data;

      if (!data.success) {
        alert(data.error || "Failed to generate PDF");
        return;
      }

      // Direct Base64 PDF URL
      const pdfDataUrl = `data:application/pdf;base64,${data.fileBase64}`;

      setPdfUrl(pdfDataUrl);
      setPdfDialogOpen(true);
      setSelectedEmployee(row);

    } catch (error) {
      console.error("Error opening report:", error);
      alert("Unable to fetch report. Please try again.");
    }
  };


  const renderPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else if (page <= 3) {
      pages.push(1, 2, 3, 4, "...", totalPages);
    } else if (page >= totalPages - 2) {
      pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
    }

    return pages;
  };

  if (loading)
    return <div className="col-12 text-center text-muted py-5">Loading...</div>;

  return (

    <>
      {(
        <>
          {/* TABLE FOR BOTH DESKTOP & MOBILE */}
          <div className="pd-table-container pd-table-wapper">
            <div className="ur-tableResponsive">
              <table className="urpd-table pd-table">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Assessment Type</th>
                    <th>Result</th>
                    <th>Scored Percentage</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {reports.length === 0 ? (
                    <TableEmptyRow colSpan={5} message="No user reports found" />
                  ) : reports.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.Title}</td>
                      <td>{row.exam_type}</td>
                      <td>{row.IsPassed ? "Pass" : "Fail"}</td>
                      {/* <td>{row.Percentage != null ? `${row.Percentage}%` : "-"}</td> */}
                      <td>
                        {row.Percentage != null
                          ? `${Number(row.Percentage).toFixed(2)}%`
                          : "-"}
                      </td>
                      <td
                        style={{
                          paddingLeft: "8px",
                          verticalAlign: "middle",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          {row.IsEnable === 1 ? (

                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleView(row)}
                            >
                              <VisibilityIcon />
                            </IconButton>

                          ) : (

                            <IconButton
                              size="small"
                              disabled
                              sx={{
                                opacity: 0.4,
                                cursor: "not-allowed"
                              }}
                            >
                              <VisibilityIcon />
                            </IconButton>

                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* PAGINATION */}
          {reports.length > 0 && <Box className="pd-pagination mobile-pagination">
            <button
              className="btn-negative"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Previous
            </button>

            {renderPageNumbers().map((num, index) => (
              <button
                key={index}
                disabled={num === "..."}
                onClick={() => typeof num === "number" && setPage(num)}
                className={`pg-type-btn ${num === page ? "active" : ""}`}
              >
                {num}
              </button>
            ))}

            <button
              className="btn-negative"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </Box>}
        </>
      )}
    </>

  );
}


